import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window | null>('WINDOW', {
  providedIn: 'root',
  factory: windowFactory,
});

export function windowFactory(): Window | null {
  return typeof window !== 'undefined' ? window : null;
}
